@use "../../styles/responsive";

$component-name: "horizontal-stack";
$alignments: start, center, end, space-around, space-between, space-evenly;
$block-alignments: start, center, end, baseline, stretch;

.horizontalStack {
  display: flex;

  @include responsive.responsive-props($component-name, "gap", "gap");
  @include responsive.responsive-props($component-name, "row-gap", "row-gap");
  @include responsive.responsive-props($component-name, "wrap", "flex-wrap");

  &.wrap {
    flex-wrap: wrap;
  }

  &.fullWidth {
    width: 100%;
  }

  &.itemsReverse {
    flex-direction: row-reverse;
  }

  &.align {
    @each $alignment in $alignments {
      &-#{$alignment} {
        justify-content: $alignment;
      }
    }
  }

  &.block-align {
    @each $alignment in $block-alignments {
      &-#{$alignment} {
        align-items: $alignment;
      }
    }
  }

  &[hidden] {
    display: none;
  }
}
